<template>
  <div class="grid text-left pr-5">
    <div class="space-y-10">
      <h5 class="bold self-start flex items-center">Order confirmed</h5>
      <div class="border border-blue-5 text-blue-1 p-4 rounded self-start grow-0 space-y-4">
        <p class="button-2">Thanks, {{ userFirstName }}!</p>
        <p class="paragraph-2">
          Welcome to Otivo — we're here to help you be better off. A confirmation email is on its
          way with everything you need to get started.
        </p>
        <p class="button-2">Order summary:</p>
        <p class="flex justify-between paragraph-2">
          {{ capitalize(props.selectedTier?.product?.name ?? '') }}
          <span class="text-right">{{
            promotionCode.formattedPrice(props.selectedTier?.price?.amount ?? 0)
          }}</span>
        </p>
        <hr class="my-3 text-grey-5" />
        <div v-if="props.appliedDiscount" class="flex justify-between paragraph-2 text-green-600">
          <span>Discount:</span>
          <span class="text-right">{{ promotionCode.formatDiscount() }}</span>
        </div>
        <p class="flex justify-between paragraph-2">
          Total (GST included):
          <span class="text-right">{{
            promotionCode.calculateFinalPrice(props.selectedTier?.price.amount ?? 0)
          }}</span>
        </p>
      </div>
    </div>
    <div class="w-full shrink self-end">
      <OtivoButton data-test="order-done" class="w-full" @click="close">Done</OtivoButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { PlanTier } from '@/composables/useTieredPlans.ts'
import OtivoButton from '@/components/OtivoButton.vue'
import { capitalize } from '@/lib/helpers'
import { usePromotionCode } from '@/composables/usePromotionCode.ts'
import { watch } from 'vue'

type Props = {
  selectedTier: PlanTier | null
  userFirstName: string
  appliedDiscount?: {
    percent_off: number | null
    amount_off: number | null
    currency: string | null
  } | null
}

const props = defineProps<Props>()

const emits = defineEmits<{ (e: 'close'): void }>()

const promotionCode = usePromotionCode()

// Set the validation state from passed props so the composable functions work
watch(
  () => props.appliedDiscount,
  (discount) => promotionCode.setValidation(discount ?? null),
  { immediate: true },
)

const close = () => {
  emits('close')
}
</script>

<style scoped></style>
